export default "__VITE_ASSET__3jlHnYuK__"